import { defineMessages } from 'react-intl'

const scope = `procurify.components.OrderItemStatusLabel`

export default defineMessages({
  purchaseOrderTooltip: {
    id: `${scope}.purchaseOrderTooltip`,
    defaultMessage: 'Purchase Order: {purchaseOrderNumber}',
  },
  punchoutOrderConfirmationTooltip: {
    id: `${scope}.punchoutOrderConfirmationTooltip`,
    defaultMessage:
      'This will not reflect changes to order status made by the supplier.',
  },
})
